import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.commissions')
  .factory('$commission', CommissionObjectFactory);

/* @ngInject */
function CommissionObjectFactory($bringozFactory: $bringozFactory,
                                 CommissionsAPI: BringozApi,
                                 Commission_DS: DataStoreConfig,
                                 Commissions_PN: PushNotificationsConfig) {
  function $commission(id: string) {
    return $bringozFactory(id, CommissionsAPI, Commission_DS, Commissions_PN)
  }

  return $commission;
}
